import React from "react"

import Variant from "./Variant"

const variants = ["base", "mini", "standard", "full"]

const Component = ({ variant, microcopy }) => <Variant variant={variant} microcopy={microcopy} />

export default Component
export { variants }
